import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  const links = {
    Explore: [
      { label: 'Art Classes', href: '/art-classes' },
      { label: 'Parties & Events', href: '/parties-events' },
      { label: 'About Us', href: '/about' },
      { label: 'Location', href: '/location' },
      { label: 'FAQs', href: '/faqs' },
    ],
    Experience: [
      { label: 'View Calendar', href: 'https://artdenstudio.com/calendar/', external: true },
      { label: 'Buy Gift Card', href: 'https://app.getoccasion.com/p/n/3mrk3shx9p7bhxywpcu9cg', external: true },
      { label: 'Book a Party', href: '/parties-events', external: false },
      { label: 'Contact Us', href: '/contact', external: false },
    ],
  };

  return (
    <footer style={{ background: '#080808' }}>
      {/* Top paint line */}
      <div className="h-[2px]" style={{ background: 'linear-gradient(90deg, #ff4322, #ffb300, #ff7120, #e0285a, #ff4322)' }} />

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12">

          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://artdenstudio.com/wp-content/uploads/2024/11/logo.png"
              alt="Art Den Studio"
              className="h-12 w-auto object-contain mb-5"
            />
            <p className="text-artden-muted text-sm leading-relaxed max-w-xs font-outfit">
              A premium art studio in Nazareth, PA offering art classes, birthday parties, private events, and creative experiences for all ages.
            </p>

            {/* Social */}
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://www.facebook.com/TheArtDenofNazareth/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-artden-muted hover:text-white hover:border-artden-coral transition-all"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a
                href="https://www.instagram.com/theartdenofnazareth/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-artden-muted hover:text-white hover:border-artden-coral transition-all"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>

            <a
              href="https://artdenstudio.com/calendar/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-artden-coral hover:brightness-110 text-white text-sm font-semibold px-6 py-3 rounded-full mt-6 transition-all whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-event-line"></i>
              </span>
              Book a Class
            </a>
          </div>

          {/* Links */}
          {Object.entries(links).map(([group, items]) => (
            <div key={group}>
              <h4 className="font-cormorant text-base font-semibold tracking-wider text-white mb-5">
                <a href="#">{group}</a>
              </h4>
              <ul className="space-y-3">
                {items.map((item) => (
                  <li key={item.label}>
                    {item.external ? (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-artden-muted hover:text-artden-coral text-sm font-outfit transition-colors"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        to={item.href}
                        className="text-artden-muted hover:text-artden-coral text-sm font-outfit transition-colors"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact row */}
        <div className="mt-14 pt-10 border-t border-white/6 grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div className="flex items-start gap-3">
            <span className="w-8 h-8 flex items-center justify-center shrink-0">
              <i className="ri-map-pin-2-line text-artden-coral"></i>
            </span>
            <div>
              <p className="text-artden-muted text-xs uppercase tracking-widest font-outfit mb-1">Location</p>
              <p className="text-white/55 text-sm font-outfit">37 E Belvidere Street<br />Nazareth, PA 18064</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="w-8 h-8 flex items-center justify-center shrink-0">
              <i className="ri-phone-line text-artden-coral"></i>
            </span>
            <div>
              <p className="text-artden-muted text-xs uppercase tracking-widest font-outfit mb-1">Phone</p>
              <a href="tel:6103400314" className="text-white/55 text-sm font-outfit hover:text-artden-coral transition-colors">610-340-0314</a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <span className="w-8 h-8 flex items-center justify-center shrink-0">
              <i className="ri-mail-line text-artden-coral"></i>
            </span>
            <div>
              <p className="text-artden-muted text-xs uppercase tracking-widest font-outfit mb-1">Email</p>
              <a href="mailto:info@artdenstudio.com" className="text-white/55 text-sm font-outfit hover:text-artden-coral transition-colors">info@artdenstudio.com</a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-artden-muted text-xs font-outfit">© The Art Den LLC {year}. All rights reserved.</p>
          <p className="text-white/15 text-xs font-outfit">37 E Belvidere Street, Nazareth, PA 18064</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
